<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="banner_box"
			>
				<img src="../../assets/img_public/contact/banner_h501.webp" />
			</div>
			<!--banner-->
			<!--块1-->
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div class="phone_box">
					<van-icon name="phone" size="24px" color="#C8000A" style="top: 4px;" />&nbsp;&nbsp;<a href="tel:010-69390623">010-69390623</a>
				</div>
				<div class="txt">公司：宝瑞源生物技术（北京）有限公司</div>
				<div class="txt">邮箱：<a href="mailto:Gene@CorDx.com">Gene@CorDx.com</a></div>
				<div class="txt">邮编：102433</div>
				<div class="txt">地址：北京市房山区窦店镇中心路8号</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="300"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_2"
			>
				<div class="title">留言</div>
				<div class="text">
					在这里，您可以在线提交您的问题与需求，我们会尽快与您联系或直接在线回复，如果急需回复，请致电010-69390623
				</div>
				<div class="block_2_el">
					<div class="tit required">您的姓名</div>
					<input v-model="username" placeholder="请留下您的姓名" autocomplete="off" />
				</div>
				<div class="block_2_el">
					<div class="tit required">手机/电话</div>
					<input v-model="userphone" placeholder="请留下您的手机/电话号码" autocomplete="off" />
				</div>
				<div class="block_2_el">
					<div class="tit">联系邮箱</div>
					<input v-model="useremail" placeholder="请留下您的邮箱地址" autocomplete="off" />
				</div>
				<div class="block_2_el">
					<div class="tit required">留言内容</div>
					<textarea v-model="usercontent" placeholder="请填写您的留言内容" autocomplete="off"></textarea>
				</div>
				<div class="btn" @click="submit">提交</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { submitMsg } from '@/api/public'  //提交留言
import md5 from 'js-md5';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			username: '',
			userphone: '',
			useremail: '',
			usercontent: '',
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		submit() {
			let that = this;
			if(that.username && that.userphone && that.usercontent) {
				that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
				submitMsg({
					name: that.username,
					mobile: that.userphone,
					email: that.useremail,
					content: that.usercontent,
					language: sessionStorage.getItem('lang'),
					access_token: md5(String(that.username)+String(that.userphone)+String(that.useremail)+'Abiores2024')
				}).then(res => {
					that.$toast.clear();
					that.username = '';
					that.userphone = '';
					that.useremail = '';
					that.usercontent = '';
					that.$toast('提交成功');
				});
			}else {
				that.$toast('请先完善留言信息');
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//块2
	.block_2{
		padding: 0 16px;
		.btn{
			width: 70%;
			margin: 30px auto 50px auto;
			padding: 10px 0;
			border: 1px solid #C8000A;
			text-align: center;
			border-radius: 4px;
			color: #C8000A;
		}
		.block_2_el{
			width: 100%;
			margin-top: 20px;
			font-size: 18px;
			.required::after{
				content: '*';
				color: #C8000A;
			}
			.tit{
				font-size: 14px;
			}
			textarea:focus{
				border: 1px solid #C8000A;
			}
			textarea{
				width: 100%;
				height: 150px;
				border: none;
				margin-top: 10px;
				padding: 10px 15px;
				background-color: #F6F6F6;
				border: 1px solid #B8B8B8;
				color: #C8000A;
				font-size: 14px;
				resize: none;
			}
			input:focus{
				border: 1px solid #C8000A;
			}
			input{
				width: 100%;
				margin-top: 10px;
				padding: 10px 15px;
				background-color: #F6F6F6;
				border: 1px solid #B8B8B8;
				color: #C8000A;
				font-size: 14px;
			}
		}
		.text{
			padding-top: 5px;
			font-size: 12px;
		}
		.title{
			font-size: 24px;
			font-weight: bold;
		}
	}
	//块1
	.block_1{
		padding: 40px 16px;
		.txt{
			padding: 2px 0;
			a{
				color: #333333;
			}
		}
		.phone_box{
			padding-bottom: 12px;
			font-size: 24px;
			a{
				color: #333333;
			}
		}
	}
	//banner
	.banner_box{
		img{
			width: 100%;
		}
	}
}
</style>